// Measurement fields captured on a cut. Special (additional work) cuts record
// quantities of work items, not dimensions, so these are removed from Special cuts
// before saving. Includes the canonical total-inches fields plus the form's
// feet/inches helper fields.
export const MEASUREMENT_FIELDS = [
    'originalLength', 'originalWidth', 'originalDepth',
    'actualLength', 'actualWidth', 'actualDepth',
    'originalLengthFeet', 'originalLengthInches',
    'originalWidthFeet', 'originalWidthInches',
    'originalDepthFeet', 'originalDepthInches',
    'actualLengthFeet', 'actualLengthInches',
    'actualWidthFeet', 'actualWidthInches',
    'actualDepthFeet', 'actualDepthInches',
];

// A cut is Special if it has specials or its product resolves to the Special surface.
function cutIsSpecial(cut) {
    if (cut?.specials?.length) {
        return true;
    }

    let product = cut?.product;
    if (typeof product === 'string' && product !== '') {
        try {
            product = JSON.parse(product);
        } catch (error) {
            return false;
        }
    }

    if (product && typeof product === 'object') {
        return (product.surface ?? product.id) === 'Special';
    }

    return false;
}

// Returns a copy of the project values with all measurement fields stripped from any
// Special cut, leaving other cuts untouched.
export function stripMeasurementsFromSpecialCuts(values) {
    if (!Array.isArray(values?.cuts)) {
        return values;
    }

    return {
        ...values,
        cuts: values.cuts.map(cut => {
            if (!cutIsSpecial(cut)) {
                return cut;
            }

            const cleaned = { ...cut };
            for (const field of MEASUREMENT_FIELDS) {
                delete cleaned[field];
            }
            return cleaned;
        }),
    };
}